<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <material-card color="primary">
          <template v-slot:header>
            <div class="px-3">
              <div class="title font-weight-bold mb-2">Apresentação</div>
            </div>
          </template>
          <v-container
            class="pa-6 ma-0"
            style="font-size: 115%; text-align: justify"
          >
            <p>
              A Central de Projetos UFMS organiza os projetos administrativos
              executados na Universidade em painéis utilizando BI (Business Intelligence).
              Com essa tecnologia, o usuário consegue uma visão dinâmica dos projetos,
              a qual facilita sua análise e reorganização de acordo com a demanda de sua unidade.
            </p>
            <p>
              Na Central de Projetos, reunem-se os projetos em andamento e
              em fila para execução futura, além dos encerrados e os suspensos.
              Os projetos são reavaliados constantemente constituindo o ciclo de melhoria contínua.
              O objetivo principal da Central de Projetos é disseminar a cultura de
              Gestão de Projetos na UFMS a fim de aprimorar a cadeia de valor.
              Outrossim, a Central de Projetos contribui a fornecer transparência sobre
              as atividades administrativas executadas na UFMS.
            </p>

          </v-container>
        </material-card>
        <!--v-row>
          <v-col cols="12" sm="4" lg="3">
            <material-stats-card
              color="green"
              icon="mdi-view-dashboard"
              title="."
              value="Visão Geral"
              sub-text="Principais informações resumidas"
            />
          </v-col>

          <v-col cols="12" sm="4" lg="3">
            <material-stats-card
              color="orange"
              icon="mdi-school"
              title="."
              value="Graduação"
              sub-text="Matriculados, Ingressos e Egressos"
            />
          </v-col>

          <v-col cols="12" sm="4" lg="3">
            <material-stats-card
              color="red"
              icon="mdi-certificate"
              title="."
              value="Pós-Graduação"
              sub-text="Matriculados, Ingressos, Egressos "
            />
          </v-col>

          <v-col cols="12" sm="4" lg="3">
            <material-stats-card
              color="info"
              icon="mdi-account-multiple"
              title="."
              value="Servidores"
              sub-text="Docentes e Técnicos"
            />
          </v-col>
        </v-row-->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  components: {
    MaterialCard: () => import("../components/material/Card"),
    MaterialStatsCard: () => import("../components/material/StatsCard"),
  },
};
</script>

<style lang="scss">
.tim-note {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  margin-left: 20px;
  width: 260px;
}
</style>
